// Modules
import React from "react"

// Styles
import "./MvError.sass"

type Props = {
    message: string
}

class MvError extends React.Component<Props> {

    constructor(prop:Props) {
        super(prop)
    }

    render () {
        return (
            <div className="four-oh-four">
                <h2>{this.props.message}</h2>
            </div>
        )
    }
}

export default MvError
